import { X, _ } from "./vendor.js";
import { COLORS, formatDateShort } from "./config.jsx";


// --- Card wrapper ---
export const Card = ({ children, style = {}, onClick, className = "" }) => (
  <div onClick={onClick} className={`shearly-card ${className}`.trim()} style={{
    background: COLORS.card, borderRadius: 12, padding: 20, boxShadow: "var(--shadow-card)",
    border: `1px solid ${COLORS.border}`, overflowX: "auto", WebkitOverflowScrolling: "touch", ...style
  }}>
    {children}
  </div>
);

// --- Stat Card ---
export const StatCard = ({ icon: Icon, label, value, trend, color }) => {
  const mob = window.innerWidth < 768;
  return (
  <div className="shearly-card stat-card" style={{ background: COLORS.card, borderRadius: 12, padding: mob ? 12 : 20, boxShadow: "var(--shadow-card)", border: `1px solid ${COLORS.border}`, display: "flex", alignItems: "center", gap: mob ? 8 : 14, cursor: "default" }}>
    <div style={{ width: mob ? 32 : 44, height: mob ? 32 : 44, borderRadius: mob ? 8 : 10, background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <Icon size={mob ? 16 : 22} color={color} />
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: mob ? 10 : 12, color: COLORS.textLight, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label}</div>
      <div style={{ fontSize: mob ? 16 : 22, fontWeight: 700, color: COLORS.text }}>{value}</div>
    </div>
    {trend && <div style={{ fontSize: mob ? 10 : 12, color: trend > 0 ? COLORS.success : COLORS.danger, fontWeight: 600 }}>{trend > 0 ? "+" : ""}{trend}%</div>}
  </div>
  );
};

// POLISH_v1: Skeleton-Komponente fuer Loading-States
export const Skeleton = ({ width = "100%", height = 14, style = {} }) => (
  <span className="shearly-skeleton" style={{ width, height, ...style }} />
);

// --- Badge ---
export const Badge = ({ text, color }) => (
  <span style={{
    display: "inline-block", padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600,
    background: `${color}18`, color: color
  }}>
    {text}
  </span>
);

// --- Button ---
export const Btn = ({ children, variant = "primary", size = "md", onClick, style = {}, disabled, type, className = "" }) => {
  const base = {
    border: "none", borderRadius: 8, cursor: disabled ? "not-allowed" : "pointer", fontWeight: 600,
    display: "inline-flex", alignItems: "center", gap: 6, transition: "all 0.18s ease",
    opacity: disabled ? 0.5 : 1, fontSize: size === "sm" ? 12 : 14,
    padding: size === "sm" ? "6px 12px" : "10px 18px",
  };
  const variants = {
    primary: { background: COLORS.primary, color: "white" },
    secondary: { background: COLORS.border, color: COLORS.text },
    success: { background: COLORS.success, color: "white" },
    danger: { background: COLORS.danger, color: "white" },
    ghost: { background: "transparent", color: COLORS.primary },
  };
  // POLISH_v1: passende hover-class pro Variante (colored shadow + lift)
  const hoverClass = `shearly-btn-${variant}`;
  return <button type={type} onClick={onClick} disabled={disabled} className={`${hoverClass} ${className}`.trim()} style={{ ...base, ...variants[variant], ...style }}>{children}</button>;
};

// --- Modal ---
export const Modal = ({ open, onClose, title, children, width = 520 }) => {
  if (!open) return null;
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        background: "var(--card)", borderRadius: 16, width, maxWidth: "95vw", maxHeight: "90vh", overflow: "auto",
        boxShadow: "0 20px 60px rgba(0,0,0,0.2)"
      }} onClick={e => e.stopPropagation()}>
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px",
          borderBottom: `1px solid ${COLORS.border}`
        }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>{title}</h3>
          <button onClick={onClose} style={{
            background: "none", border: "none", cursor: "pointer", padding: 4, borderRadius: 6
          }}>
            <X size={18} color={COLORS.textLight} />
          </button>
        </div>
        <div style={{ padding: 20 }}>{children}</div>
      </div>
    </div>
  );
};

// --- Input ---
export const Input = ({ label, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: COLORS.text, marginBottom: 4 }}>{label}</label>}
    <input {...props} style={{
      width: "100%", padding: "8px 12px", border: `1px solid ${COLORS.border}`, borderRadius: 8,
      fontSize: 14, outline: "none", boxSizing: "border-box", ...props.style
    }} />
  </div>
);

export const Select = ({ label, options, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: COLORS.text, marginBottom: 4 }}>{label}</label>}
    <select {...props} style={{
      width: "100%", padding: "8px 12px", border: `1px solid ${COLORS.border}`, borderRadius: 8,
      fontSize: 14, outline: "none", background: "var(--card)", boxSizing: "border-box", ...props.style
    }}>
      {options.map(o => <option key={o.value} value={o.value} disabled={o.disabled} style={o.disabled ? {background:'#e0e0e0',color:'#999'} : {}}>{o.label}</option>)}
    </select>
  </div>
);

// ============================================================
// BOOKING MODAL
// ============================================================

// PAUSE_TIME_COMBO_v1 -- Zeit-Eingabe kann BEIDES: frei tippen UND aus scrollbarer Vorschlagsliste
// (datalist) waehlen. PAUSE_TIME_OPTS = 5-Min-Vorschlaege 06:00-22:00. normTime() macht beim Verlassen
// des Feldes aus "1430"/"14"/"14.30" sauberes "HH:MM" (tolerant, leert nie ein gueltiges Feld).
export const PAUSE_TIME_OPTS = (() => { const a = []; for (let m = 6 * 60; m <= 22 * 60; m += 5) a.push(String(Math.floor(m / 60)).padStart(2, "0") + ":" + String(m % 60).padStart(2, "0")); return a; })();
export const normTime = (v) => { if (!v) return v; const d = String(v).replace(/\D/g, ""); if (!d) return v; let hh, mm; if (d.length <= 2) { hh = d; mm = "00"; } else { hh = d.slice(0, d.length - 2); mm = d.slice(-2); } const H = Math.min(23, parseInt(hh, 10) || 0); const M = Math.min(59, parseInt(mm, 10) || 0); return String(H).padStart(2, "0") + ":" + String(M).padStart(2, "0"); };
// PAUSE_TIME_COMBO_v2 -- eigenes Zeit-Eingabefeld: frei TIPPEN + eigene SCROLLBARE Liste (klicken).
// Ersetzt das native datalist, das auf Safari unzuverlaessig war (Liste kam nur beim Tippen, nicht per Klick).
// Tippen wird beim Verlassen via normTime() zu sauberem HH:MM. Liste = PAUSE_TIME_OPTS (5-Min, 06:00-22:00).
export const TimeCombo = ({ value, onChange, style }) => {
    const [open, setOpen] = React.useState(false);
    const wrapRef = React.useRef(null);
    const selRef = React.useRef(null);
    React.useEffect(() => {
        if (!open) return;
        if (selRef.current) { try { selRef.current.scrollIntoView({ block: "center" }); } catch (_) {} }
        const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);
    return (
        <div ref={wrapRef} style={{ position: "relative" }}>
            <input type="text" inputMode="numeric" placeholder="HH:MM" style={style}
                value={value || ""}
                onChange={e => onChange(e.target.value)}
                onFocus={() => setOpen(true)}
                onClick={() => setOpen(true)}
                onBlur={() => onChange(normTime(value))} />
            <div onMouseDown={e => e.preventDefault()} style={{ display: open ? "block" : "none", position: "absolute", top: "100%", left: 0, right: 0, zIndex: 30, maxHeight: 200, overflowY: "auto", background: "var(--card)", border: `1px solid ${COLORS.border}`, borderRadius: 8, marginTop: 4, boxShadow: "0 8px 24px rgba(0,0,0,0.3)" }}>
                {PAUSE_TIME_OPTS.map(t => {
                    const sel = t === value;
                    return <div key={t} ref={sel ? selRef : null}
                        onMouseDown={() => { onChange(t); setOpen(false); }}
                        style={{ padding: "8px 12px", cursor: "pointer", fontSize: 14, color: "var(--text)", background: sel ? `${COLORS.primary}22` : "transparent", fontWeight: sel ? 700 : 400 }}>{t}</div>;
                })}
            </div>
        </div>
    );
};

// DATE_DMY_INPUT_v1 -- Freies Tipp-Datumsfeld "TT.MM.JJJJ" statt nativem Kalender.
// Gerade fuer Geburtsjahre praktisch: einfach 8 Ziffern tippen, Punkte kommen automatisch,
// kein Zurueckklicken durch Jahrzehnte. value/onChange arbeiten mit ISO "JJJJ-MM-TT"
// (Backend unveraendert). Unvollstaendig/ungueltig -> "" (Feld ist optional).
export function DateDMYInput({ value, onChange, style, placeholder }) {
  const isoToDisplay = (iso) => {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return "";
    const [y, m, d] = iso.split("-");
    return `${d}.${m}.${y}`;
  };
  const [text, setText] = React.useState(isoToDisplay(value));
  React.useEffect(() => { setText(isoToDisplay(value)); }, [value]);
  const handle = (raw) => {
    const digits = String(raw).replace(/\D/g, "").slice(0, 8);
    let out = digits;
    if (digits.length > 4) out = digits.slice(0, 2) + "." + digits.slice(2, 4) + "." + digits.slice(4);
    else if (digits.length > 2) out = digits.slice(0, 2) + "." + digits.slice(2);
    setText(out);
    if (digits.length === 8) {
      const dd = digits.slice(0, 2), mm = digits.slice(2, 4), yy = digits.slice(4);
      const dN = +dd, mN = +mm, yN = +yy;
      const nowY = new Date().getFullYear();
      const chk = new Date(yN, mN - 1, dN);
      const valid = mN >= 1 && mN <= 12 && dN >= 1 && dN <= 31 && yN >= 1900 && yN <= nowY
        && chk.getDate() === dN && chk.getMonth() === mN - 1 && chk.getFullYear() === yN;
      onChange(valid ? `${yy}-${mm}-${dd}` : "");
    } else {
      onChange("");
    }
  };
  return <input style={style} type="text" inputMode="numeric" autoComplete="off"
    placeholder={placeholder || "TT.MM.JJJJ"} value={text} maxLength={10}
    onChange={e => handle(e.target.value)} />;
}


// CUST_DUP_HINT_v1 (Toby 20.09.2026) -- gelber Hinweiskasten "Diesen Kunden gibt es vielleicht schon".
// Nur Hinweis, keine Sperre: das Anlegen bleibt möglich (Mutter/Tochter mit derselben Nummer).
export const DupCustomerHint = ({ hits, onPick, pickLabel = "Diesen Kunden nehmen" }) => {
  if (!hits || !hits.length) return null;
  return (
    <div data-dup-hint="1" style={{ margin: "0 0 10px", padding: "8px 10px", borderRadius: 8, background: `${COLORS.warning}14`, border: `1.5px solid ${COLORS.warning}` }}>
      <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: COLORS.text }}>
        ⚠️ {hits.length === 1 ? "Diesen Kunden gibt es vielleicht schon:" : "Diese Kunden gibt es vielleicht schon:"}
      </div>
      {hits.map(h => {
        const c = h.customer;
        const why = h.samePhone && h.sameName ? "gleicher Name und gleiche Nummer" : h.samePhone ? "gleiche Telefonnummer" : "gleicher Name";
        return (
          <div key={c.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, flexWrap: "wrap", padding: "4px 0" }}>
            <div style={{ fontSize: 12.5, color: COLORS.text, minWidth: 0 }}>
              <strong>{c.name}</strong>{c.phone ? ` · ${c.phone}` : ""}
              <div style={{ fontSize: 11, color: COLORS.textLight }}>
                {why}{c.lastVisit ? ` · letzter Besuch ${formatDateShort(c.lastVisit)}` : ""}
              </div>
            </div>
            <button type="button" onClick={() => onPick && onPick(c)} style={{
              padding: "5px 10px", borderRadius: 6, border: `1px solid ${COLORS.warning}`, background: "var(--card)",
              color: COLORS.text, fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
              {pickLabel}
            </button>
          </div>
        );
      })}
      <div style={{ fontSize: 10.5, color: COLORS.textLight, marginTop: 4 }}>
        Nur ein Hinweis – wenn es wirklich jemand anderes ist (z. B. Mutter und Tochter), einfach wie gewohnt anlegen.
      </div>
    </div>
  );
};
